import {
  DeliveredWeeklyTierList,
  WeeklyTierList,
} from "@dimensional-engineering/dimensional-models";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type WeeklyTierListSlice = {
  latestTierList: WeeklyTierList | null;
  deliveredForLatest: DeliveredWeeklyTierList | null;
  weeklyTierListLoaded: boolean;
};

const initialState: WeeklyTierListSlice = {
  latestTierList: null,
  deliveredForLatest: null,
  weeklyTierListLoaded: false,
};

export const weeklyTierList = createSlice({
  name: "weeklyTierList",
  initialState: initialState,
  reducers: {
    setLatestWeeklyTierList: (
      state,
      action: PayloadAction<WeeklyTierList | null>
    ) => {
      return { ...state, latestTierList: action.payload };
    },
    setDeliveredWeeklyTierList: (
      state,
      action: PayloadAction<DeliveredWeeklyTierList | null>
    ) => {
      return { ...state, deliveredForLatest: action.payload };
    },
    setWeeklyTierListLoaded: (state, action: PayloadAction<boolean>) => {
      return { ...state, weeklyTierListLoaded: action.payload };
    },
  },
});

export const {
  setLatestWeeklyTierList,
  setDeliveredWeeklyTierList,
  setWeeklyTierListLoaded,
} = weeklyTierList.actions;

export default weeklyTierList.reducer;
